import {
  FETCH_ALL_USERS,
  FETCH_ALL_USERS_SUCCESS,
  FETCH_ALL_USERS_FAILED,
  EDIT_USER,
  EDIT_USER_SUCCESS,
  EDIT_USER_FAILED,
  DELETE_USER,
  DELETE_USER_SUCCESS,
  DELETE_USER_FAILED,
  FETCH_ALL_DOCTORS,
  FETCH_ALL_DOCTORS_SUCCESS,
  FETCH_ALL_DOCTORS_FAILED,
} from "../store/types";

export const fetchUsers = () => (dispatch) => (firebase) => {

  const {
    usersRef
  } = firebase;

  dispatch({
    type: FETCH_ALL_USERS,
    payload: null
  });
  usersRef.on("value", snapshot => {
    if (snapshot.val()) {
      const data = snapshot.val();
      
      const arr = Object.keys(data)
      .filter(i => data[i].userType!='admin')
      .map(i => {
        data[i].id = i;
        return data[i];
      });
      dispatch({
        type: FETCH_ALL_USERS_SUCCESS,
        payload: arr
      });
    } else {
      dispatch({
        type: FETCH_ALL_USERS_FAILED,
        payload: "No users available."
      });
    }
  });
};

export const fetchDoctors = () => (dispatch) => (firebase) => {

  const {
    usersRef
  } = firebase;

  dispatch({
    type: FETCH_ALL_DOCTORS,
    payload: null,
  });
  
  usersRef.orderByChild("queue").equalTo(false).once("value", snapshot => {
    if (snapshot.val()) {
      const data = snapshot.val();
      const arr = Object.keys(data)
      
      .map(i => {
        data[i].id = i;
        return data[i];
      });
      dispatch({
        type: FETCH_ALL_DOCTORS_SUCCESS,
        payload: arr,
      });
    } else {
      dispatch({
        type: FETCH_ALL_DOCTORS_FAILED,
        payload: "No Docs available.",
      });
    }
  });
};

export const addUser = (userdata) => (dispatch) => (firebase) => {
  const {
    usersRef
  } = firebase;

  dispatch({
    type: EDIT_USER,
    payload: userdata
  });

  usersRef.push(userdata).then(() => {
    dispatch({
      type: EDIT_USER_SUCCESS,
      payload: null
    });
  }).catch((error) => {
    dispatch({
      type: EDIT_USER_FAILED,
      payload: error
    });
  });
}

export const editUser = (id, user) => (dispatch) => (firebase) => {

  const {
    singleUserRef
  } = firebase;

  dispatch({
    type: EDIT_USER,
    payload: user
  });
  let editedUser = user;
  delete editedUser.id;
  singleUserRef(id).update(editedUser).then(() => {
    dispatch({
      type: EDIT_USER_SUCCESS,
      payload: null
    });
  }).catch((error) => {
    dispatch({
      type: EDIT_USER_FAILED,
      payload: error
    });
  });
}

export const deleteUser = (id) => (dispatch) => (firebase) => {

  const {
    singleUserRef
  } = firebase;

  dispatch({
    type: DELETE_USER,
    payload: id
  });

  singleUserRef(id).remove().then(() => {
    dispatch({
      type: DELETE_USER_SUCCESS,
      payload: null
    });
  }).catch((error) => {
    dispatch({
      type: DELETE_USER_FAILED,
      payload: error
    });
  });
}

  // dependantsRef: (uid) => app.database().ref("users/" + uid+ "dependants/"),
export const AddDependants = (id, dependant) => (dispatch) => (firebase) => {
  const { dependantsRef } = firebase;

  console.log("id:", id);
  console.log("dependant:", dependant);
  console.log("ref:", dependantsRef(id).toString());

  dependantsRef(id)
    .push(dependant) // <-- append instead of overwrite
    .then(() => {
      // alert("Dependant added successfully");
    })
    .catch((error) => {
      alert("Error adding dependant: " + error.message);
    });
};



